import React from 'react';

// Maps a delivery/health status string to one of the three global badge tones
// (status-up / status-degraded / status-down). Keeps the colour logic in one
// place instead of being re-derived inline across the admin screens.
const TONE_BY_STATUS = {
  sent: 'up',
  success: 'up',
  delivered: 'up',
  up: 'up',
  ok: 'up',
  failed: 'down',
  error: 'down',
  down: 'down',
  queued: 'degraded',
  pending: 'degraded',
  retrying: 'degraded',
  degraded: 'degraded',
};

function StatusBadge({ status, label, className = '' }) {
  const key = String(status || '').toLowerCase();
  const tone = TONE_BY_STATUS[key] || 'degraded';
  return (
    <span className={`status-badge status-${tone} ${className}`.trim()}>
      {label || status}
    </span>
  );
}

export default StatusBadge;
